import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { PencilSquare, Trash } from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";

function ListStaff() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const isArchivedList =
    AppConstants.routes.admin.archivedEvents.includes(pathname);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("");

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const resp = await authCall("getStaff", {});
      if (resp?.type === "success") {
        setStaffList(resp?.payload);
        setLoading(false);
      }
    }
    fetchData();
  }, [isArchivedList]);


  const handleEdit = (details) => {
    navigate(AppConstants.routes.admin.addHotelStaff, {
      state: { details},
    });
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
        >
          Yes
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    const resp = await authCall("deleteStaff", {
      staffId: el.id,
      isSoft: false
    });
    if (resp?.type === "success") {
      closeToast();
      const updatedItems = staffList.filter((item) => item.id !== el.id);
      setStaffList(updatedItems);
      toast.success("Deleted successfully.");
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">
                  Staff List
                </div>
                <div className="details-wrapper py-lg-4">
                  <div className="table-responsive">
                    <table className="table table-borderless table-custom m-0">
                      <thead>
                        <tr>
                          <th scope="col">Id:</th>
                          <th scope="col">QR:</th>
                          <th scope="col">User Type:</th>
                          <th scope="col">Company:</th>
                          <th scope="col">Staff:</th>
                          <th scope="col">Action:</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading &&
                          (staffList.length > 0 ? (
                            staffList.map((el, index) => (
                              <tr key={index}>
                                <td>#{el.id}</td>
                                <td>
                                  <img
                                    src={el?.qr_image}
                                    alt="el.qr_image"
                                    style={{ width: 80, borderRadius: 5 }}
                                  />
                                  <br/>
                                  <a href={el?.qr_image} target="_blank">Download</a>
                                </td>
                                <td>{el.user_type}</td>
                                <td>{el.company_name}</td>
                                <td>
                                  
                                </td>
                                <td>
                                  <div className="icon-container">
                                    <PencilSquare
                                      onClick={() => handleEdit(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "#ddb12e",
                                      }}
                                    />
                                    <Trash
                                      onClick={() => handleDelete(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "red",
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No record found
                              </td>
                            </tr>
                          ))}
                        {loading && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListStaff;
